import { Button, Container, Group, Text, Title } from '@mantine/core';
import { Link } from 'react-router-dom';

function Settings() {
  return (
    <Container size="sm" py="xl">
      <Title order={2}>Settings</Title>
      <Text c="dimmed" mt="sm">
        Personal Application Settings
      </Text>
      <Group mt="xl">
        <Button component={Link} to="/billing">
          Open Billing
        </Button>
      </Group>
    </Container>
  );
}

export default Settings;
